/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const UpdatePeerFeedbackSettingsAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['amount', codecNumber],
    ['time', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
    ['autoApproved', codecBoolean, 'auto_approved'],
    [
        'redivideAfterDeadline',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'redivide_after_deadline',
    ],
]);
export class UpdatePeerFeedbackSettingsAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UpdatePeerFeedbackSettingsAssignmentDataParser.decode(input).map(res => new UpdatePeerFeedbackSettingsAssignmentData(res));
    }
    static unsafeDecode(input) {
        return UpdatePeerFeedbackSettingsAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpdatePeerFeedbackSettingsAssignmentDataParser.encode(data);
    }
    static schema() {
        return UpdatePeerFeedbackSettingsAssignmentDataParser.schema();
    }
}
